import { Component, Input } from '@angular/core';
import { TypographyComponent } from 'components';

@Component({
	standalone: true,
	selector: 'app-star-rating-bar',
	templateUrl: './star-rating-bar.component.html',
	styleUrls: ['./star-rating-bar.component.scss'],
	imports: [TypographyComponent]
})
export class StarRatingBarComponent {
	@Input() rating = 5;
	@Input() count = 0;
	@Input() maxCount = 0;

	get barPercentage(): number {
		if (this.maxCount === 0) return 0;
		return Math.round((this.count / this.maxCount) * 90);
	}

	get formattedCount(): string {
		if (this.count >= 1_000_000) {
			const value = this.count / 1_000_000;
			return `${Number.isInteger(value) ? value : value.toFixed(1)}m`;
		}
		if (this.count >= 1_000) {
			const value = this.count / 1_000;
			return `${Number.isInteger(value) ? value : value.toFixed(1)}k`;
		}
		return `${this.count}`;
	}
}
